const investorTypes = {
    development: {
        private_equity: 5950,
        venture_capital: 5954
    },
    production: {
        private_equity: 5950,
        venture_capital: 5954
    }
}
export const INVESTOR_TYPE = investorTypes[process.env.NODE_ENV];
